import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { Button, Dialog } from '@material-ui/core';
import PickSqCheckBox from '~/components/CheckBox/PickSqCheckBox';
import '~/font.css';

class Pick extends Component {
  state={ functions: [], functionsName: [] }
  componentDidMount () {
    this.props.getFuncList();
  }

  componentDidUpdate (preProps) {
    const { open: preOpen } = preProps;
    const { open, value, nameValue } = this.props;
    if (!preOpen && open) this.setState({ functions: value, functionsName: nameValue });
  }

  onChangeFunc=(id, name) => {
    const { functions: f, functionsName: f2 } = this.state;
    const functions = JSON.parse(JSON.stringify(f));
    const functionsName = JSON.parse(JSON.stringify(f2));
    if (functions.indexOf(id) > -1) {
      functions.splice(functions.indexOf(id), 1);
      functionsName.splice(functionsName.indexOf(name), 1);
    } else {
      functions.push(id);
      functionsName.push(name);
    }
    this.setState({ functions, functionsName });
  }

  renderDialog=() => {
    const { funcList = [], onCancel = () => {}, onCheck = () => {} } = this.props;
    const { functions, functionsName } = this.state;
    const ary = [];
    for (let i = 0; i < funcList.length; i++) ary.push(...funcList[i].list);
    return (
      <div style={{ width: 875 - 45, backgroundColor: 'white', borderRadius: 39, alignItems: 'start', display: 'flex', flexDirection: 'column', paddingLeft: 45, paddingTop: 31, paddingBottom: 30 }}>
        <div className='Noto_Sans_TC' style={{ fontSize: 25, fontWeight: 700, marginBottom: 11 }}>挑選功能</div>
        <div className='Noto_Sans_SC' style={{ marginTop: 10, display: 'flex' }}>
          <div style={{ width: 296 - 45, fontWeight: 500, fontSize: 15 }}>系統</div>
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 15 + 269, display: 'flex', marginBottom: 8 }}>
                <PickSqCheckBox value={functions.indexOf('login') > -1} onClick={this.onChangeFunc} id={'login'} name={'登入作業'} />
                <div style={{ marginLeft: 7, fontSize: 13, fontWeight: 400 }}>{'登入作業'}</div>
              </div>
            </div>
          </div>
        </div>
        {ary.map((o, i) => {
          const list = [];
          if (!o.leaf) {
            for (let i2 = 0; i2 < o.list.length; i2 += 2) {
              if (o.list[i2 + 1]) list.push([o.list[i2], o.list[i2 + 1]]);
              else list.push([o.list[i2]]);
            }
          } else list.push([{ name: o.name, value: o.value }]);
          return (
            <div key={o.id} className='Noto_Sans_SC' style={{ marginTop: 10, display: 'flex' }}>
              <div style={{ width: 296 - 45, fontWeight: 500, fontSize: 15 }}>{o.name}</div>
              <div>
                {list.map((array, i2) => (
                  <div key={i2} style={{ display: 'flex' }}>
                    {array.map(o3 => (
                      <div key={o3.value} style={{ width: 15 + 269, display: 'flex', marginBottom: 8 }}>
                        <PickSqCheckBox value={functions.indexOf(o3.value) > -1} onClick={this.onChangeFunc} id={o3.value} name={o3.name} />
                        <div style={{ marginLeft: 7, fontSize: 13, fontWeight: 400 }}>{o3.name}</div>
                      </div>
                    ))}
                  </div>
                ))}
                <div style={{ display: 'flex' }}>
                  <div style={{ width: 15 + 269, display: 'flex' }} />
                </div>
              </div>
            </div>
          );
        })}
        <div style={{ marginTop: 29, width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Button style={{ width: 156, height: 47, borderRadius: 8, backgroundColor: '#B8B8B8', color: 'white', fontSize: 20, fontWeight: 500, letterSpacing: '0.1em' }} onClick={onCancel}>取消</Button>
          <Button style={{ width: 156, height: 47, borderRadius: 8, backgroundColor: '#34D6E0', color: 'white', fontSize: 20, fontWeight: 500, letterSpacing: '0.1em', marginLeft: 16 }} onClick={() => { onCheck(functions, functionsName); }}>確認</Button>
        </div>
      </div>
    );
  }

  render () {
    const { open = false } = this.props;
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={open}
      />
    );
  }
}

const mapStateToProps = state => ({
  funcList: state.data.FuncList,
});
const mapDispatchToProps = dispatch => ({
  getFuncList: () => Actions.getFuncList(dispatch),
});

const App_Pick = connect(mapStateToProps, mapDispatchToProps)(Pick);
const App = (props = { open: false, onCancel: () => {}, onCheck: () => {}, value: [], nameValue: [] }) => <App_Pick {...props} />;
export default App;
